/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogDiscountCategoryDTO,
  CatalogDiscountCategoryDTOOptional,
  CatalogDiscountCategoryDTOMetaI,
  CatalogDiscountCategoryDTOTrackedI,
} from "./catalog-discount-category-dto";
import {
  CatalogDiscountCategoryDTOTracked,
  CatalogDiscountCategoryDTOMeta,
} from "./catalog-discount-category-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogDiscountInstanceDTO,
  CatalogDiscountInstanceDTOOptional,
  CatalogDiscountInstanceDTOMetaI,
  CatalogDiscountInstanceDTOTrackedI,
} from "./catalog-discount-instance-dto";
import {
  CatalogDiscountInstanceDTOTracked,
  CatalogDiscountInstanceDTOMeta,
} from "./catalog-discount-instance-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemDiscountDTO,
  CatalogItemDiscountDTOOptional,
  CatalogItemDiscountDTOMetaI,
  CatalogItemDiscountDTOTrackedI,
} from "./catalog-item-discount-dto";
import {
  CatalogItemDiscountDTOTracked,
  CatalogItemDiscountDTOMeta,
} from "./catalog-item-discount-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogRef,
  CatalogRefOptional,
  CatalogRefMetaI,
  CatalogRefTrackedI,
} from "./catalog-ref";
import { CatalogRefTracked, CatalogRefMeta } from "./catalog-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountFull,
  DiscountFullOptional,
  DiscountFullMetaI,
  DiscountFullTrackedI,
} from "./discount-full";
import { DiscountFullTracked, DiscountFullMeta } from "./discount-full";

/**
 *
 * @export
 * @interface CatalogDiscountDTO
 */
export interface CatalogDiscountDTOOptional extends DiscountFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountDTO
   */
  discountName?: string;
  /**
   *
   * @type {CatalogRef}
   * @memberof CatalogDiscountDTO
   */
  catalogId?: CatalogRefOptional;
  /**
   *
   * @type {Array<CatalogDiscountCategoryDTO>}
   * @memberof CatalogDiscountDTO
   */
  categories?: CatalogDiscountCategoryDTOOptional[];
  /**
   *
   * @type {Array<CatalogDiscountInstanceDTO>}
   * @memberof CatalogDiscountDTO
   */
  instances?: CatalogDiscountInstanceDTOOptional[];
  /**
   *
   * @type {Array<CatalogItemDiscountDTO>}
   * @memberof CatalogDiscountDTO
   */
  itemDiscounts?: CatalogItemDiscountDTOOptional[];
}

export interface CatalogDiscountDTO
  extends CatalogDiscountDTOOptional, DiscountFull {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountDTO
   */
  discountName: string;
  /**
   *
   * @type {CatalogRef}
   * @memberof CatalogDiscountDTO
   */
  catalogId?: CatalogRef;
  /**
   *
   * @type {Array<CatalogDiscountCategoryDTO>}
   * @memberof CatalogDiscountDTO
   */
  categories?: CatalogDiscountCategoryDTO[];
  /**
   *
   * @type {Array<CatalogDiscountInstanceDTO>}
   * @memberof CatalogDiscountDTO
   */
  instances?: CatalogDiscountInstanceDTO[];
  /**
   *
   * @type {Array<CatalogItemDiscountDTO>}
   * @memberof CatalogDiscountDTO
   */
  itemDiscounts?: CatalogItemDiscountDTO[];
}

export interface CatalogDiscountDTOTrackedI extends DiscountFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountDTO
   */
  discountName?: string;
  discountNameIsSet: boolean;
  /**
   *
   * @type {CatalogRef}
   * @memberof CatalogDiscountDTO
   */
  catalogId?: CatalogRefTrackedI;
  catalogIdIsSet: boolean;
  /**
   *
   * @type {Array<CatalogDiscountCategoryDTO>}
   * @memberof CatalogDiscountDTO
   */
  categories?: CatalogDiscountCategoryDTOTrackedI[];
  categoriesIsSet: boolean;
  /**
   *
   * @type {Array<CatalogDiscountInstanceDTO>}
   * @memberof CatalogDiscountDTO
   */
  instances?: CatalogDiscountInstanceDTOTrackedI[];
  instancesIsSet: boolean;
  /**
   *
   * @type {Array<CatalogItemDiscountDTO>}
   * @memberof CatalogDiscountDTO
   */
  itemDiscounts?: CatalogItemDiscountDTOTrackedI[];
  itemDiscountsIsSet: boolean;
}

transformDatesMap.set(
  "CatalogDiscountDTO",
  function (model: CatalogDiscountDTO) {
    const transformDatescatalogId = transformDatesMap.get("CatalogRef");
    if (transformDatescatalogId && model.catalogId) {
      transformDatescatalogId(model.catalogId);
    }
    const transformDatescategories = transformDatesMap.get(
      "CatalogDiscountCategoryDTO",
    );
    if (transformDatescategories) {
      model.categories?.forEach((sub) => {
        transformDatescategories(sub);
      });
    }
    const transformDatesinstances = transformDatesMap.get(
      "CatalogDiscountInstanceDTO",
    );
    if (transformDatesinstances) {
      model.instances?.forEach((sub) => {
        transformDatesinstances(sub);
      });
    }
    const transformDatesitemDiscounts = transformDatesMap.get(
      "CatalogItemDiscountDTO",
    );
    if (transformDatesitemDiscounts) {
      model.itemDiscounts?.forEach((sub) => {
        transformDatesitemDiscounts(sub);
      });
    }
  },
);

export type CatalogDiscountDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  discountName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  catalogId: PropertyMeta<CatalogRefMetaI>;
  //isDate: false
  //isDatetime: false
  categories: PropertyMeta<CatalogDiscountCategoryDTOMetaI>;
  //isDate: false
  //isDatetime: false
  instances: PropertyMeta<CatalogDiscountInstanceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  itemDiscounts: PropertyMeta<CatalogItemDiscountDTOMetaI>;
}>;

export var CatalogDiscountDTOMeta: CatalogDiscountDTOMetaI =
  {} as CatalogDiscountDTOMetaI;
CatalogDiscountDTOMeta = typeMeta("CatalogDiscountDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  discountName: propertyMeta(
    "discountName",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  catalogId: propertyMeta("catalogId", false, false, false, CatalogRefMeta),
  categories: propertyMeta(
    "categories",
    true,
    false,
    false,
    CatalogDiscountCategoryDTOMeta,
  ),
  instances: propertyMeta(
    "instances",
    true,
    false,
    false,
    CatalogDiscountInstanceDTOMeta,
  ),
  itemDiscounts: propertyMeta(
    "itemDiscounts",
    true,
    false,
    false,
    CatalogItemDiscountDTOMeta,
  ),
});

const metaI = CatalogDiscountDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DiscountFullMeta]);
  metaI.isDeleted.inheritedFrom = DiscountFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = DiscountFullMeta.isNew;
  metaI.assignId.inheritedFrom = DiscountFullMeta.assignId;
  metaI.tempID.inheritedFrom = DiscountFullMeta.tempID;
  metaI.discountName.inheritedFrom = DiscountFullMeta.discountName;
  metaI.catalogId.inheritedFrom = DiscountFullMeta.catalogId;
  metaI.categories.inheritedFrom = DiscountFullMeta.categories;
  metaI.instances.inheritedFrom = DiscountFullMeta.instances;
  metaI.itemDiscounts.inheritedFrom = DiscountFullMeta.itemDiscounts;
});

export class CatalogDiscountDTOTracked
  extends DiscountFullTracked
  implements CatalogDiscountDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  discountName__I?: string = undefined;
  discountNameIsSet: boolean = false;
  set discountName(v: undefined | string) {
    if (v !== undefined) {
      this.discountName__I = v;
      this.discountNameIsSet = true;
    } else {
      this.discountName__I = v || undefined;
      this.discountNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get discountName() {
    return this.discountName__I;
  }
  catalogId__I?: CatalogRefTracked = undefined;
  catalogIdIsSet: boolean = false;
  set catalogId(v: undefined | CatalogRefTracked) {
    if (v !== undefined) {
      this.catalogId__I = v;
      this.catalogIdIsSet = true;
    } else {
      this.catalogId__I = v || undefined;
      this.catalogIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get catalogId() {
    return this.catalogId__I;
  }
  categories__I?: CatalogDiscountCategoryDTOTracked[] = undefined;
  categoriesIsSet: boolean = false;
  set categories(v: undefined | CatalogDiscountCategoryDTOTracked[]) {
    if (v !== undefined) {
      this.categories__I = v;
      this.categoriesIsSet = true;
    } else {
      this.categories__I = v || undefined;
      this.categoriesIsSet = false;
    }
    this.changeTracker = true;
  }
  get categories() {
    return this.categories__I;
  }
  instances__I?: CatalogDiscountInstanceDTOTracked[] = undefined;
  instancesIsSet: boolean = false;
  set instances(v: undefined | CatalogDiscountInstanceDTOTracked[]) {
    if (v !== undefined) {
      this.instances__I = v;
      this.instancesIsSet = true;
    } else {
      this.instances__I = v || undefined;
      this.instancesIsSet = false;
    }
    this.changeTracker = true;
  }
  get instances() {
    return this.instances__I;
  }
  itemDiscounts__I?: CatalogItemDiscountDTOTracked[] = undefined;
  itemDiscountsIsSet: boolean = false;
  set itemDiscounts(v: undefined | CatalogItemDiscountDTOTracked[]) {
    if (v !== undefined) {
      this.itemDiscounts__I = v;
      this.itemDiscountsIsSet = true;
    } else {
      this.itemDiscounts__I = v || undefined;
      this.itemDiscountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemDiscounts() {
    return this.itemDiscounts__I;
  }
  constructor(config?: CatalogDiscountDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.catalogId?.setIds();

    this.categories?.forEach((a) => a.setIds());

    this.instances?.forEach((a) => a.setIds());

    this.itemDiscounts?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: CatalogDiscountDTOOptional,
    options?: AssignOptions,
  ): CatalogDiscountDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.discountName &&
      this.discountNameApplyFilter(optionsRequired.filter)
    ) {
      this.discountName = config.discountName;
      if (optionsRequired.unassign) this.discountNameIsSet = false;
      else this.discountNameIsSet = true;
    }
    if (config.catalogId && this.catalogIdApplyFilter(optionsRequired.filter)) {
      this.catalogId = new CatalogRefTracked(config.catalogId, options);
      if (optionsRequired.unassign) this.catalogIdIsSet = false;
      else this.catalogIdIsSet = true;
    }
    if (
      config.categories &&
      this.categoriesApplyFilter(optionsRequired.filter)
    ) {
      this.categories = config.categories?.map(
        (a) => new CatalogDiscountCategoryDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.categoriesIsSet = false;
      else this.categoriesIsSet = true;
    }
    if (config.instances && this.instancesApplyFilter(optionsRequired.filter)) {
      this.instances = config.instances?.map(
        (a) => new CatalogDiscountInstanceDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.instancesIsSet = false;
      else this.instancesIsSet = true;
    }
    if (
      config.itemDiscounts &&
      this.itemDiscountsApplyFilter(optionsRequired.filter)
    ) {
      this.itemDiscounts = config.itemDiscounts?.map(
        (a) => new CatalogItemDiscountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemDiscountsIsSet = false;
      else this.itemDiscountsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogDiscountDTOTrackedI {
    const cloned = {} as CatalogDiscountDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.discountNameIsSetDeep() &&
      this.discountNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountNameIsSet = true;
      cloned.discountName = this.discountName;
    } else {
      //cloned.discountNameIsSet = false
    }
    if (
      this.catalogIdIsSetDeep() &&
      this.catalogIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.catalogIdIsSet = true;
      cloned.catalogId = this.catalogId?.removeUnset(filter);
    } else {
      //cloned.catalogIdIsSet = false
    }
    if (
      this.categoriesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.categoriesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoriesIsSet = true;
      cloned.categories = this.categories
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.categoriesIsSet = false
    }
    if (
      this.instancesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.instancesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instancesIsSet = true;
      cloned.instances = this.instances
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.instancesIsSet = false
    }
    if (
      this.itemDiscountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemDiscountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemDiscountsIsSet = true;
      cloned.itemDiscounts = this.itemDiscounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemDiscountsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogDiscountDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.discountNameApplyFilter(filter)) this.discountNameIsSet = false;

    if (!this.catalogIdApplyFilter(filter)) this.catalogIdIsSet = false;
    this.catalogId?.unassignAll(filter);

    if (!this.categoriesApplyFilter(filter)) this.categoriesIsSet = false;

    this.categories?.forEach((a) => a.unassignAll(filter));
    if (!this.instancesApplyFilter(filter)) this.instancesIsSet = false;

    this.instances?.forEach((a) => a.unassignAll(filter));
    if (!this.itemDiscountsApplyFilter(filter)) this.itemDiscountsIsSet = false;

    this.itemDiscounts?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountDTOMeta.isDeleted,
      CatalogDiscountDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountDTOMeta.isNew,
      CatalogDiscountDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountDTOMeta.assignId,
      CatalogDiscountDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountDTOMeta.tempID,
      CatalogDiscountDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  discountNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountDTOMeta.discountName,
      CatalogDiscountDTOMeta,
      this.discountName,
      this,
    );
  }
  discountNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountNameIsSet && this.discountNameApplyFilter(filter))
      return true;

    return false;
  }
  catalogIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountDTOMeta.catalogId,
      CatalogDiscountDTOMeta,
      this.catalogId,
      this,
    );
  }
  catalogIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.catalogIdIsSet && this.catalogIdApplyFilter(filter)) return true;
    return this.catalogId?.anySet(filter) == true;

    return false;
  }
  categoriesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountDTOMeta.categories,
      CatalogDiscountDTOMeta,
      this.categories,
      this,
    );
  }
  categoriesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoriesIsSet && this.categoriesApplyFilter(filter)) return true;

    return this.categories?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  instancesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountDTOMeta.instances,
      CatalogDiscountDTOMeta,
      this.instances,
      this,
    );
  }
  instancesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instancesIsSet && this.instancesApplyFilter(filter)) return true;

    return this.instances?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  itemDiscountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountDTOMeta.itemDiscounts,
      CatalogDiscountDTOMeta,
      this.itemDiscounts,
      this,
    );
  }
  itemDiscountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemDiscountsIsSet && this.itemDiscountsApplyFilter(filter))
      return true;

    return this.itemDiscounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.discountNameIsSetDeep(filter)) return true;
    if (this.catalogIdIsSetDeep(filter)) return true;
    if (this.categoriesIsSetDeep(filter)) return true;
    if (this.instancesIsSetDeep(filter)) return true;
    if (this.itemDiscountsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
